import { useEffect } from "react";
import Cashsales from '../table/Tablecashsales';
import Modal from "../modal/Modaladdcommodity"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    {/* <Modal/> */}
    <Cashsales/>
    
     
     </>
  );
};

export default Dashboard;
